export function getGaugeOptions(cpuCount) {
    return {
        series: [
            {
                type: 'gauge',
                min: 0, max: 100,
                startAngle: 210, endAngle: -30,
                splitNumber: cpuCount,
                radius: "90%",
                center: ['50%', '55%'],
                axisLine: {
                    lineStyle: {
                        width: 30,
                        color: [
                            [0.5, '#73bf69'],
                            [0.8, '#eab839'],
                            [1, '#f2495c']
                        ]
                    }
                },
                axisTick: {
                    "show": false
                },
                splitLine: {
                    "show": false
                },
                axisLabel: {
                    "show": false
                },
                pointer: {
                    icon: 'path://M12.8,0.7l12,40.1H0.7L12.8,0.7z',
                    length: '25%',
                    width: 15,
                    offsetCenter: [0, '-40%'],
                    itemStyle: {
                        color: 'auto'
                    }
                },
                detail: {
                    valueAnimation: true,
                    formatter: '{value}',
                    color: 'inherit',
                    offsetCenter: [0, '5%'],
                },
                title: {
                    offsetCenter: [0, '50%'],
                    fontSize: 14,
                    fontWeight: 'bolder',
                    color: '#687d8b'
                },
                data: [
                    {
                        value: 0,
                        name: 'loading..'
                    },
                ]
            }
        ]
    }
}